import * as React from 'react';
import { observer } from 'mobx-react';

import LeaveEditModeModal, { Props } from './LeaveEditModeModal';
import ModalReactions from '../../../../../../Modal/ModalReactions';

const LeaveEditMode: React.FC<Props> = (props) => (
  <>
    <LeaveEditModeModal {...props} />
    <ModalReactions store={props.modalStore} />
  </>
);

export default observer(LeaveEditMode);
